"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Timer = _interopRequireDefault(require("../../../Timer"));
var _Name = _interopRequireDefault(require("../../Clients/Name"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _dialer = require("../../../../icons-react/dialer");
var _excluded = ["operator", "call"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var States = {
  AFTER_SERVICE: 'after_service',
  BANNED: 'banned',
  DND: 'dnd',
  OFFLINE: 'offline',
  ONLINE: 'online',
  IN_SERVICE: 'servicing',
  READY: 'ready'
};
var LOCK_TIMEOUT = 4000;
var Operator = /*#__PURE__*/function (_React$PureComponent) {
  function Operator(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Operator);
    _this = _callSuper(this, Operator, [props]);
    _this.state = {
      locked: false
    };
    _this.handleCall = _this.handleCall.bind(_this);
    _this.handleListen = _this.handleListen.bind(_this);
    _this.handleTransfer = _this.handleTransfer.bind(_this);
    _this.handleRequestHelp = _this.handleRequestHelp.bind(_this);
    _this.toggleOperatorLock = _this.toggleOperatorLock.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Operator, _React$PureComponent);
  return (0, _createClass2["default"])(Operator, [{
    key: "handleRequestHelp",
    value: function handleRequestHelp() {
      var _this$props = this.props,
        operator = _this$props.operator,
        onRequestHelp = _this$props.onRequestHelp;
      onRequestHelp({
        supervisorID: operator.number
      });
      this.toggleOperatorLock(true);
    }
  }, {
    key: "handleTransfer",
    value: function handleTransfer() {
      var _this$props2 = this.props,
        operator = _this$props2.operator,
        onTransfer = _this$props2.onTransfer;
      onTransfer({
        operatorId: operator.number
      });
      this.toggleOperatorLock(true);
    }
  }, {
    key: "handleListen",
    value: function handleListen() {
      var _this$props3 = this.props,
        call = _this$props3.call,
        onListen = _this$props3.onListen;
      var pbxId = call.pbxId;
      onListen({
        pbxId: pbxId
      });
      this.toggleOperatorLock(true);
    }
  }, {
    key: "handleCall",
    value: function handleCall() {
      var _this$props4 = this.props,
        operator = _this$props4.operator,
        onCall = _this$props4.onCall;
      onCall({
        value: operator.number
      });
      this.toggleOperatorLock(true);
    }
  }, {
    key: "toggleOperatorLock",
    value: function toggleOperatorLock() {
      var locked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.setState({
        locked: locked
      });
      if (locked) {
        setTimeout(this.toggleOperatorLock, LOCK_TIMEOUT);
      }
    }
  }, {
    key: "about",
    value: function about() {
      var _this$props5 = this.props,
        contact = _this$props5.contact,
        operator = _this$props5.operator;
      var operatorName = operator.name,
        skillGroups = operator.skillGroups;
      return /*#__PURE__*/_react["default"].createElement(StyledAbout, null, /*#__PURE__*/_react["default"].createElement(StyledAboutTitle, null, /*#__PURE__*/_react["default"].createElement(StyledOperatorName, {
        name: operatorName
      }), skillGroups && /*#__PURE__*/_react["default"].createElement(StyledGroups, null, skillGroups.join()), this.helpers()), !!contact && /*#__PURE__*/_react["default"].createElement(StyledClient, null, contact.isHidden ? 'Номер скрыт' : /*#__PURE__*/_react["default"].createElement(StyledNumber, null, contact.name, contact.number && " (".concat(contact.number, ")"))));
    }
  }, {
    key: "actions",
    value: function actions() {
      var operator = this.props.operator;
      var locked = this.state.locked;
      var canCall = operator.canCall,
        canTransfer = operator.canTransfer;
      return /*#__PURE__*/_react["default"].createElement(StyledActions, null, canCall && /*#__PURE__*/_react["default"].createElement(StyledActionButton, {
        disabled: locked,
        onClick: this.handleCall
      }, /*#__PURE__*/_react["default"].createElement(StyledCallIcon, null)), canTransfer && /*#__PURE__*/_react["default"].createElement(StyledActionButton, {
        disabled: locked,
        onClick: this.handleTransfer
      }, /*#__PURE__*/_react["default"].createElement(StyledTransferIcon, null)));
    }
  }, {
    key: "helpers",
    value: function helpers() {
      var _this$props6 = this.props,
        call = _this$props6.call,
        operator = _this$props6.operator;
      var hasPbxId = call && call.pbxId;
      var locked = this.state.locked;
      var canListen = operator.canListen,
        canRequestHelp = operator.canRequestHelp;
      return /*#__PURE__*/_react["default"].createElement(StyledHelpers, null, hasPbxId && canListen && /*#__PURE__*/_react["default"].createElement(StyledActionButton, {
        disabled: locked,
        onClick: this.handleListen
      }, /*#__PURE__*/_react["default"].createElement(StyledListenIcon, null)), canRequestHelp && /*#__PURE__*/_react["default"].createElement(StyledActionButton, {
        disabled: locked,
        onClick: this.handleRequestHelp
      }, /*#__PURE__*/_react["default"].createElement(StyledHelpIcon, null)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        operator = _this$props7.operator,
        call = _this$props7.call,
        props = (0, _objectWithoutProperties2["default"])(_this$props7, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledOperator, props, Operator.status(operator), this.actions(), this.about(), call && Operator.duration(call));
    }
  }], [{
    key: "status",
    value: function status(_ref) {
      var number = _ref.number,
        state = _ref.state;
      var isServicing = state === States.IN_SERVICE;
      return /*#__PURE__*/_react["default"].createElement(StyledStatus, {
        status: state
      }, isServicing && /*#__PURE__*/_react["default"].createElement(StyledOnAirIcon, null), number, isServicing && /*#__PURE__*/_react["default"].createElement(StyledOnAirIcon, null));
    }
  }, {
    key: "duration",
    value: function duration(_ref2) {
      var _duration = _ref2.duration;
      return _duration && /*#__PURE__*/_react["default"].createElement(StyledDuration, {
        key: _duration,
        initialSeconds: _duration,
        format: "m:ss"
      });
    }
  }]);
}(_react["default"].PureComponent);
Operator.propTypes = {
  className: _propTypes["default"].string,
  call: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    pbxId: _propTypes["default"].string,
    duration: _propTypes["default"].number
  }),
  contact: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    number: _propTypes["default"].number,
    isHidden: _propTypes["default"].bool
  }),
  operator: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    number: _propTypes["default"].string.isRequired,
    state: _propTypes["default"].string.isRequired,
    skillGroups: _propTypes["default"].arrayOf(_propTypes["default"].string),
    canCall: _propTypes["default"].bool.isRequired,
    canTransfer: _propTypes["default"].bool.isRequired,
    canListen: _propTypes["default"].bool.isRequired,
    canRequestHelp: _propTypes["default"].bool.isRequired,
    isCallCenter: _propTypes["default"].bool
  }).isRequired,
  onCall: _propTypes["default"].func,
  onTransfer: _propTypes["default"].func,
  onListen: _propTypes["default"].func,
  onRequestHelp: _propTypes["default"].func
};
Operator.defaultProps = {
  className: '',
  call: null,
  contact: null,
  onCall: Function.prototype,
  onTransfer: Function.prototype,
  onListen: Function.prototype,
  onRequestHelp: Function.prototype
};
var StyledOperator = _styledComponents["default"].li.withConfig({
  displayName: "Operator__StyledOperator",
  componentId: "sc-1338izd-0"
})(["width:100%;display:flex;margin:10px 0;align-items:center;"]);
var StyledStatus = _styledComponents["default"].div.withConfig({
  displayName: "Operator__StyledStatus",
  componentId: "sc-1338izd-1"
})(["width:38px;color:#17181a;margin:0 10px;font-size:14px;position:relative;border-radius:2px;text-align:center;padding:2px 0 3px;", " ", " ", " ", ""], function (p) {
  return p.status === States.DND && "\n    color: #fff;\n    background-image: linear-gradient(to right, #e5200e, #ff860c);\n  ";
}, function (p) {
  return p.status === States.ONLINE && "\n    background-image: linear-gradient(to right, #f7aa1b, #faed61);\n  ";
}, function (p) {
  return p.status === States.READY && "\n    color: #fff;\n    background-image: linear-gradient(to right, #00b0b6, #00c87f);\n  ";
}, function (p) {
  return ![States.DND, States.IN_SERVICE, States.ONLINE, States.READY].includes(p.status) && "\n    color: #919499;\n    border: 1px solid #919499;\n  ";
});
var StyledOnAirIcon = (0, _styledComponents["default"])(_dialer.OnAir).withConfig({
  displayName: "Operator__StyledOnAirIcon",
  componentId: "sc-1338izd-2"
})(["top:0;height:17px;right:-3px;position:absolute;&:first-child{left:-3px;transform:rotate(180deg);}"]);
var StyledActions = _styledComponents["default"].div.withConfig({
  displayName: "Operator__StyledActions",
  componentId: "sc-1338izd-3"
})(["width:22px;margin-right:7px;"]);
var StyledHelpers = _styledComponents["default"].div.withConfig({
  displayName: "Operator__StyledHelpers",
  componentId: "sc-1338izd-4"
})(["position:relative;"]);
var StyledActionButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Operator__StyledActionButton",
  componentId: "sc-1338izd-5"
})(["cursor:pointer;padding:0;border:0;width:auto;height:auto;overflow:visible;background:none;line-height:normal;", ""], function (p) {
  return p.disabled && "\n    opacity: .9;\n    pointer-events: none;\n  ";
});
var StyledListenIcon = (0, _styledComponents["default"])(_dialer.Listen).withConfig({
  displayName: "Operator__StyledListenIcon",
  componentId: "sc-1338izd-6"
})(["width:15px;height:auto;cursor:pointer;margin-top:-6px;margin-left:7px;vertical-align:middle;"]);
var StyledHelpIcon = (0, _styledComponents["default"])(_dialer.Help).withConfig({
  displayName: "Operator__StyledHelpIcon",
  componentId: "sc-1338izd-7"
})(["width:23px;height:auto;cursor:pointer;margin-top:-5px;margin-left:7px;vertical-align:middle;"]);
var StyledAbout = _styledComponents["default"].div.withConfig({
  displayName: "Operator__StyledAbout",
  componentId: "sc-1338izd-8"
})(["flex:1;min-width:250px;padding-right:40px;box-sizing:border-box;"]);
var StyledAboutTitle = _styledComponents["default"].div.withConfig({
  displayName: "Operator__StyledAboutTitle",
  componentId: "sc-1338izd-9"
})(["display:flex;"]);
var StyledOperatorName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "Operator__StyledOperatorName",
  componentId: "sc-1338izd-10"
})(["color:#1b63ac;font-size:14px;font-weight:normal;min-width:fit-content;"]);
var StyledGroups = _styledComponents["default"].span.withConfig({
  displayName: "Operator__StyledGroups",
  componentId: "sc-1338izd-11"
})(["color:#919499;overflow:hidden;text-align:left;margin-left:10px;margin-right:2px;white-space:nowrap;text-overflow:ellipsis;"]);
var StyledClient = _styledComponents["default"].div.withConfig({
  displayName: "Operator__StyledClient",
  componentId: "sc-1338izd-12"
})(["color:#17181a;font-size:12px;text-align:left;"]);
var StyledNumber = _styledComponents["default"].div.withConfig({
  displayName: "Operator__StyledNumber",
  componentId: "sc-1338izd-13"
})(["font-size:12px;"]);
var StyledDuration = (0, _styledComponents["default"])(_Timer["default"]).withConfig({
  displayName: "Operator__StyledDuration",
  componentId: "sc-1338izd-14"
})(["width:45px;font-size:14px;text-align:right;font-weight:normal;"]);
var StyledTransferIcon = (0, _styledComponents["default"])(_dialer.Transfer).withConfig({
  displayName: "Operator__StyledTransferIcon",
  componentId: "sc-1338izd-15"
})(["cursor:pointer;height:auto;vertical-align:middle;width:22px;path{stroke:#1b63ac;}"]);
var StyledCallIcon = (0, _styledComponents["default"])(_dialer.Call).withConfig({
  displayName: "Operator__StyledCallIcon",
  componentId: "sc-1338izd-16"
})(["cursor:pointer;height:auto;vertical-align:middle;width:18px;path{stroke:#1b63ac;}"]);
Operator.States = States;
var _default = exports["default"] = Operator;